/**
 * Upsell Block — variant selection + AJAX add-to-cart
 * Uses document-level event delegation so it keeps working even after
 * Dawn-style sections re-render their HTML via the Section Rendering API.
 */
(function () {
  function formatMoney(cents) {
    // Basic fallback formatter; Shopify's Currency.formatMoney can replace this
    // if your theme exposes a money format string.
    return '$' + (cents / 100).toFixed(2);
  }

  function getCard(el) {
    return el.closest('[data-upsell-card]');
  }

  // --- Variant change: update price + image ---
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-upsell-variant-select]');
    if (!select) return;

    var card = getCard(select);
    if (!card) return;

    var option = select.options[select.selectedIndex];
    var price = option.getAttribute('data-price');
    var comparePrice = option.getAttribute('data-compare-price');
    var image = option.getAttribute('data-image');

    var priceEl = card.querySelector('[data-upsell-price-current]');
    if (priceEl && price) {
      if (comparePrice && parseInt(comparePrice, 10) > parseInt(price, 10)) {
        priceEl.innerHTML =
          '<span class="upsell-block__price--sale">' + formatMoney(price) + '</span>' +
          '<span class="upsell-block__price--compare">' + formatMoney(comparePrice) + '</span>';
      } else {
        priceEl.textContent = formatMoney(price);
      }
    }

    var imgEl = card.querySelector('[data-upsell-image]');
    if (imgEl && image) {
      imgEl.src = image;
    }

    var addBtn = card.querySelector('[data-upsell-add]');
    if (addBtn) {
      addBtn.disabled = !option.disabled ? false : true;
    }
  });

  // --- Add to cart ---
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;

    var card = getCard(btn);
    if (!card) return;

    var select = card.querySelector('[data-upsell-variant-select]');
    var messageEl = card.querySelector('[data-upsell-message]');
    var labelEl = btn.querySelector('[data-upsell-btn-label]');

    if (!select || !select.value) return;

    var variantId = select.value;
    var originalLabel = labelEl ? labelEl.textContent : '+ Add';

    btn.disabled = true;
    if (labelEl) labelEl.textContent = 'Adding...';
    if (messageEl) {
      messageEl.textContent = '';
      messageEl.classList.remove('is-success', 'is-error');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || 'Could not add to cart');
          });
        }
        return res.json();
      })
      .then(function () {
        if (messageEl) {
          messageEl.textContent = 'Added to cart';
          messageEl.classList.add('is-success');
        }
        refreshCart();
      })
      .catch(function (err) {
        if (messageEl) {
          messageEl.textContent = err.message || 'Something went wrong';
          messageEl.classList.add('is-error');
        }
      })
      .finally(function () {
        btn.disabled = false;
        if (labelEl) labelEl.textContent = originalLabel;
      });
  });

  // --- Refresh cart drawer / bubble (Dawn-style themes) ---
  function refreshCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      fetch('/?sections=cart-drawer,cart-icon-bubble')
        .then(function (res) {
          if (!res.ok) return null;
          return res.json();
        })
        .then(function (sections) {
          if (!sections) return;

          if (sections['cart-drawer']) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
            var newDrawer = doc.querySelector('cart-drawer');
            if (newDrawer && cartDrawer.parentNode) {
              cartDrawer.innerHTML = newDrawer.innerHTML;
            }
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else {
              cartDrawer.classList.add('active', 'animate');
            }
          }

          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && sections['cart-icon-bubble']) {
            var parser2 = new DOMParser();
            var doc2 = parser2.parseFromString(sections['cart-icon-bubble'], 'text/html');
            var newBubble = doc2.getElementById('cart-icon-bubble');
            if (newBubble) bubble.innerHTML = newBubble.innerHTML;
          }
        })
        .catch(function () {
          /* silent fail — cart was still added successfully */
        });
    } else {
      // Fallback: just refresh the cart icon bubble count if no drawer exists
      var bubbleOnly = document.getElementById('cart-icon-bubble');
      if (bubbleOnly) {
        fetch('/?sections=cart-icon-bubble')
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .then(function (sections) {
            if (!sections || !sections['cart-icon-bubble']) return;
            var parser = new DOMParser();
            var doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
            var newBubble = doc.getElementById('cart-icon-bubble');
            if (newBubble) bubbleOnly.innerHTML = newBubble.innerHTML;
          })
          .catch(function () {});
      }
    }
  }
})();